import React from 'react';
import { Route } from 'react-router-dom';

const NotLogged = () => {
    const link =
        'https://id-qas.malwee.com.br/connect/authorize?response_type=code&client_id=prestserv-ui&scope=prestserv-ui-fullaccess&redirect_uri=https://prestserv-qas.malwee.com.br/login';
    console.log('NotLogged => So redirect to ', link);
    window.location.href = link;
    return null;
};

export const PrivateRouter = ({ component: Component, isAuthenticated, ...rest }) => {
    return <Route {...rest} render={props => (isAuthenticated ? <Component {...props} /> : <NotLogged />)} />;
};

// export const PrivateRouter = ({ component: Component, isAuthenticated, ...rest }) => {
//     return <Route {...rest} render={props => <Component {...props} />} />;
// };

export default PrivateRouter;
